// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-134Ll","header":"header-2l-8n","group":"group-11v-b"};